import React from 'react';
import { getWork, setDeleteWorkMulti } from '../../api/work'
import { typework } from '../../api/list'
import PageList from '../../components/PageListAPI'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom';
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';


export default function WorkList(props) {
  const can = useCan()
  const columns = [
    { id: 'number', name: 'Номер', },
    { id: 'name', name: 'Наименование', },
    { id: 'storageUnit', name: 'Ед. изм.', },
    { id: 'count', name: 'Количество', },
    { id: 'balance', name: 'Выполнено', },
    { id: 'done', name: 'Осталось', },
    { id: 'typeW', name: 'Тип', },
    { id: 'price', name: 'Стоимость единицы', },
  ].filter(el => typeof el === 'object')
  const toLinkPrice = React.forwardRef((props1, ref) => (<Link ref={ref} to={props.match.url + '/price'} {...props1} />))
  const toLinkLoad = React.forwardRef((props1, ref) => (<Link ref={ref} to='/multi/material/load' {...props1} />));
  const toLinkLoadTemplate = React.forwardRef((props1, ref) => (<Link ref={ref} to={props.match.url + '/load-template'} {...props1} />));
  const toLinkBasket = React.forwardRef((props1, ref) => (<Link ref={ref} to={props.match.url + '/basket'} {...props1} />));
  return (
    <div className='App-paper'>
      <PageList
        name='workList'
        title='Список работ'
        columns={columns}
        createItem={can(SLUGS.PROJECT.WORK.MANAGE)}
        deleteItem={can(SLUGS.PROJECT.WORK.MANAGE)}
        loadAPI={{
          param: {
            id: props.match.params.idProject
          },
          transform: (res => {
            return {
              count: res.count,
              get: res.get.map(obj => {
                return { ...obj, done: Math.round((obj.count - obj.balance) * 1000) / 1000 }
              })
            }
          }),
          request: getWork,
        }}
        deleteAPI={setDeleteWorkMulti(props.match.params.idProject)}
        disabledDelete={obj => obj.balance > 0}
        headerLink={
          <React.Fragment>
            {can(SLUGS.PROJECT.WORK.MANAGE) && <Button component={toLinkLoad} color="primary" >Загрузить </Button>}
            {can(SLUGS.PROJECT.WORK.MANAGE) && <Button component={toLinkLoadTemplate} color="primary" >Загрузить из шаблона</Button>}
            {can(SLUGS.PROJECT.WORK.MANAGE) && <Button component={toLinkPrice} color='primary'>Изменить цены</Button>}
            {can(SLUGS.PROJECT.WORK.MANAGE) && <Button component={toLinkBasket} color='primary'>Корзина</Button>}
          </React.Fragment>
        }
        click={can(SLUGS.PROJECT.WORK.MANAGE)}
        filterProps={[
          {
            type: 'find_text',
            field: 'find',
            name: 'Поиск по наименованию'
          },
          {
            type: 'autocomplite',
            path: typework.getList.path,
            field: 'idType',
            name: 'Тип работ',
          },
        ]}
        deleteMulti
        deleteMultiProps='arr'
        {...props}
      />
    </div>
  )
}